import "core-js/modules/es6.number.constructor";
import "vant/es/image-preview/style";
import _ImagePreview from "vant/es/image-preview";
import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.set";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.to-string";
import _typeof from "E:/workSpacke/screening-sys/node_modules/@babel/runtime/helpers/esm/typeof.js";
/**
 * Created by jiachenpan on 16/11/18.
 */

export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null;
  }
  var format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  var date;
  if (_typeof(time) === 'object') {
    date = time;
  } else {
    if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
      time = parseInt(time);
    }
    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  var formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  var time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, function (result, key) {
    var value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value];
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value;
    }
    return value || 0;
  });
  return time_str;
}
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000;
  } else {
    time = +time;
  }
  var d = new Date(time);
  var now = Date.now();
  var diff = (now - d) / 1000;
  if (diff < 30) {
    return '刚刚';
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前';
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前';
  } else if (diff < 3600 * 24 * 2) {
    return '1天前';
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分';
  }
}

// 格式化时间
export function getQueryObject(url) {
  url = url == null ? window.location.href : url;
  var search = url.substring(url.lastIndexOf('?') + 1);
  var obj = {};
  var reg = /([^?&=]+)=([^?&=]*)/g;
  search.replace(reg, function (rs, $1, $2) {
    var name = decodeURIComponent($1);
    var val = decodeURIComponent($2);
    val = String(val);
    obj[name] = val;
    return rs;
  });
  return obj;
}

/**
 * @param {Sting} input value
 * @returns {number} output value
 */
export function byteLength(str) {
  // returns the byte length of an utf8 string
  var s = str.length;
  for (var i = str.length - 1; i >= 0; i--) {
    var code = str.charCodeAt(i);
    if (code > 0x7f && code <= 0x7ff) s++;else if (code > 0x7ff && code <= 0xffff) s += 2;
    if (code >= 0xDC00 && code <= 0xDFFF) i--;
  }
  return s;
}
export function cleanArray(actual) {
  var newArray = [];
  for (var i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i]);
    }
  }
  return newArray;
}
export function param(json) {
  if (!json) return '';
  return cleanArray(Object.keys(json).map(function (key) {
    if (json[key] === undefined) return '';
    return encodeURIComponent(key) + '=' + encodeURIComponent(json[key]);
  })).join('&');
}
export function param2Obj(url) {
  var search = url.split('?')[1];
  if (!search) {
    return {};
  }
  return JSON.parse('{"' + decodeURIComponent(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"').replace(/\+/g, ' ') + '"}');
}

// 获取链接参数
export function getParams() {
  var s = window.location.search.substr(1);
  var o = new Object();
  var aryVars = s.split('&');
  for (var i = 0; i < aryVars.length; i++) {
    var index = aryVars[i].indexOf('=');
    var aryPair = [aryVars[i].substring(0, index), aryVars[i].substring(index + 1)];
    o[aryPair[0]] = aryPair[1];
  }
  return o;
}

//获取过滤某个参数后的url
export function getFilterUrl(key) {
  var origin = window.location.pathname;
  var param = window.location.search.substring(1);
  var pmArr = param.split("&");
  var v = "";
  var _itemArr = [];
  var _key;
  for (var i = 0, j = pmArr.length; i < j; i++) {
    _itemArr = pmArr[i].split("=");
    _key = _itemArr[0];
    if (pmArr[i] !== "" && key != _key) {
      if (v === "") {
        v += "?" + pmArr[i];
      } else {
        v += "&" + pmArr[i];
      }
    }
  }
  return origin + v;
}

//根据输入链接获取过滤某个参数后的url
export function filterUrl(url, key) {
  var url_arr = url.split("?");
  var origin = url_arr[0];
  var param = url_arr[1];
  if (param == undefined) {
    return url;
  }
  var pmArr = param.split("&");
  var v = "";
  var _itemArr = [];
  var _key;
  for (var i = 0, j = pmArr.length; i < j; i++) {
    _itemArr = pmArr[i].split("=");
    _key = _itemArr[0];
    if (pmArr[i] !== "" && key != _key) {
      if (v === "") {
        v += "?" + pmArr[i];
      } else {
        v += "&" + pmArr[i];
      }
    }
  }
  return origin + v;
}
export function html2Text(val) {
  var div = document.createElement('div');
  div.innerHTML = val;
  return div.textContent || div.innerText;
}
export function objectMerge(target, source) {
  /* Merges two  objects,
     giving the last one precedence */

  if (_typeof(target) !== 'object') {
    target = {};
  }
  if (Array.isArray(source)) {
    return source.slice();
  }
  Object.keys(source).forEach(function (property) {
    var sourceProperty = source[property];
    if (_typeof(sourceProperty) === 'object') {
      target[property] = objectMerge(target[property], sourceProperty);
    } else {
      target[property] = sourceProperty;
    }
  });
  return target;
}
export function toggleClass(element, className) {
  if (!element || !className) {
    return;
  }
  var classString = element.className;
  var nameIndex = classString.indexOf(className);
  if (nameIndex === -1) {
    classString += '' + className;
  } else {
    classString = classString.substr(0, nameIndex) + classString.substr(nameIndex + className.length);
  }
  element.className = classString;
}
export var pickerOptions = [{
  text: '今天',
  onClick: function onClick(picker) {
    var end = new Date();
    var start = new Date(new Date().toDateString());
    end.setTime(start.getTime());
    picker.$emit('pick', [start, end]);
  }
}, {
  text: '最近一周',
  onClick: function onClick(picker) {
    var end = new Date(new Date().toDateString());
    var start = new Date();
    start.setTime(end.getTime() - 3600 * 1000 * 24 * 7);
    picker.$emit('pick', [start, end]);
  }
}, {
  text: '最近一个月',
  onClick: function onClick(picker) {
    var end = new Date(new Date().toDateString());
    var start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
    picker.$emit('pick', [start, end]);
  }
}, {
  text: '最近三个月',
  onClick: function onClick(picker) {
    var end = new Date(new Date().toDateString());
    var start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
    picker.$emit('pick', [start, end]);
  }
}];
export function getTime(type) {
  if (type === 'start') {
    return new Date().getTime() - 3600 * 1000 * 24 * 90;
  } else {
    return new Date(new Date().toDateString());
  }
}

// iframe 打印
export function iframePrint(classname) {
  var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var csslink = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  //判断iframe是否存在，不存在则创建iframe
  var iframe = document.getElementById("print-iframe");
  if (!iframe) {
    var el = document.querySelector("." + classname);
    iframe = document.createElement("IFRAME");
    var doc = null;
    iframe.setAttribute("id", "print-iframe");
    iframe.setAttribute("style", "position:absolute;width:0px;height:0px;left:-500px;top:-500px;");
    document.body.appendChild(iframe);
    doc = iframe.contentWindow.document;
    //这里可以接外链自定义样式
    doc.write('<head><link rel="stylesheet" type="text/css" href="' + csslink + '"></head>');
    doc.write("<style>" + style + "</style>");
    doc.write("<div>" + el.innerHTML + "</div>");
    console.log(doc);
    doc.close();
    iframe.contentWindow.focus();
  }
  // 加载成功后再打印
  iframe.onload = function () {
    iframe.contentWindow.print();
    document.body.removeChild(iframe);
  };
}

// iframe 打印 + 去掉页眉页脚
export function iframePrintForStatisTics(classname) {
  var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var csslink = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  //判断iframe是否存在，不存在则创建iframe
  var iframe = document.getElementById("print-iframe");
  if (!iframe) {
    var el = document.querySelector("." + classname);
    iframe = document.createElement("IFRAME");
    var doc = null;
    iframe.setAttribute("id", "print-iframe");
    iframe.setAttribute("style", "position:absolute;width:0px;height:0px;left:-500px;top:-500px;");
    document.body.appendChild(iframe);
    doc = iframe.contentWindow.document;
    //这里可以接外链自定义样式
    doc.write('<head><link rel="stylesheet" type="text/css" href="' + csslink + '"></head>');
    // 打印时去掉页眉页脚
    doc.write('<style media="print">@page {size: auto;  margin: 0mm; }</style>');
    doc.write("<style>" + style + "</style>");
    doc.write("<div>" + el.innerHTML + "</div>");
    console.log(doc);
    doc.close();
    iframe.contentWindow.focus();
  }
  // 加载成功后再打印
  iframe.onload = function () {
    iframe.contentWindow.print();
    document.body.removeChild(iframe);
  };
}

// iframe 打印（多份报表） + 去掉页眉页脚
export function iframePrintForStatisTicsMul(classname) {
  var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var csslink = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  //判断iframe是否存在，不存在则创建iframe
  var iframe = document.getElementById("print-iframe");
  if (!iframe) {
    var el = document.querySelectorAll("." + classname);
    iframe = document.createElement("IFRAME");
    var doc = null;
    iframe.setAttribute("id", "print-iframe");
    iframe.setAttribute("style", "position:absolute;width:0px;height:0px;left:-500px;top:-500px;");
    document.body.appendChild(iframe);
    doc = iframe.contentWindow.document;
    //这里可以接外链自定义样式
    doc.write('<head><link rel="stylesheet" type="text/css" href="' + csslink + '"></head>');
    // 打印时去掉页眉页脚
    doc.write('<style media="print">@page {size: auto;  margin: 0mm; }</style>');
    doc.write("<style>" + style + "</style>");
    el.forEach(function (item) {
      doc.write("<div>" + item.innerHTML + "</div>" + "<div style='page-break-after:always'></div>");
    });
    doc.close();
    iframe.contentWindow.focus();
  }

  // 加载成功后再打印
  iframe.onload = function () {
    iframe.contentWindow.print();
    document.body.removeChild(iframe);
  };
}

// iframe 分析报表打印
export function iframeReportPrint(classname) {
  var style = '.report-print-box { padding: 30px; } .report-print-box * { margin: 0; } .report-print-box h5 { text-align: center; font-size: 22px; padding-bottom: 20px; } .report-print-box h6 { font-size: 20px; padding: 10px 0; } .report-print-box p { font-size: 18px; padding: 10px 20px; font-weight: bold; } .report-print-box ul { width: 100%; zoom: 1; padding-bottom: 20px; padding-left: 0px;} .report-print-box ul:after { display: block; content: ""; clear: both; } .report-print-box ul li {width:20%; font-size: 16px; float: left; text-align: center; list-style: none; border: 1px solid #ddd; min-height: 64px;padding: 16px 0 16px;} .report-print-box ul li span { display: block; }.report-print-box .top10{padding-bottom: 20px; display: flex; flex-wrap: wrap;} .report-print-box .top10 .list{ width: 20%;font-size: 16px;text-align: center;list-style: none; border: 1px solid #ddd;min-height: 64px; padding: 16px 0 16px;display: flex;flex-wrap: wrap;justify-content: center;align-items: center;}';
  iframePrint(classname, style);
}

/**
 * 数字存储大小格式化
 * @param {number} num 存储大小 单位：Byte
 * @param {number} digits 保留几位小数
 * @return {string} 2MB
 */
export function toStorage(num, digits) {
  digits = digits || 2;
  if (num < 1024) {
    return num + 'B';
  }
  num = num * 1000 / 1024;
  var si = [{
    value: 1e18,
    symbol: 'E'
  }, {
    value: 1e15,
    symbol: 'P'
  }, {
    value: 1e12,
    symbol: 'T'
  }, {
    value: 1e9,
    symbol: 'G'
  }, {
    value: 1e6,
    symbol: 'M'
  }, {
    value: 1e3,
    symbol: 'K'
  }];
  for (var i = 0; i < si.length; i++) {
    if (num >= si[i].value) {
      return (num / si[i].value).toFixed(digits).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + si[i].symbol + 'B';
    }
  }
}
export function debounce(func, wait, immediate) {
  var timeout, args, context, timestamp, result;
  var later = function later() {
    // 据上一次触发时间间隔
    var last = +new Date() - timestamp;

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      }
    }
  };
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key2 = 0; _key2 < _len; _key2++) {
      args[_key2] = arguments[_key2];
    }
    context = this;
    timestamp = +new Date();
    var callNow = immediate && !timeout;
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }
    return result;
  };
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 */
export function deepClone(source) {
  if (!source && _typeof(source) !== 'object') {
    throw new Error('error arguments', 'deepClone');
  }
  var targetObj = source.constructor === Array ? [] : {};
  Object.keys(source).forEach(function (keys) {
    if (source[keys] && _typeof(source[keys]) === 'object') {
      targetObj[keys] = deepClone(source[keys]);
    } else {
      targetObj[keys] = source[keys];
    }
  });
  return targetObj;
}
export function uniqueArr(arr) {
  return Array.from(new Set(arr));
}
export function createUniqueString() {
  var timestamp = +new Date() + '';
  var randomNum = parseInt((1 + Math.random()) * 65536) + '';
  return (+(randomNum + timestamp)).toString(32);
}
export function hasClass(ele, cls) {
  return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'));
}
export function addClass(ele, cls) {
  if (!hasClass(ele, cls)) ele.className += ' ' + cls;
}
export function removeClass(ele, cls) {
  if (hasClass(ele, cls)) {
    var reg = new RegExp('(\\s|^)' + cls + '(\\s|$)');
    ele.className = ele.className.replace(reg, ' ');
  }
}
export function setDocumentTitle() {
  var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "index";
  if (window.document.title === title) {
    return;
  }
  document.title = title;
  var mobile = navigator.userAgent.toLowerCase();
  if (/iphone|ipad|ipod/.test(mobile)) {
    var iframe = document.createElement("iframe");
    iframe.style.display = "none";
    // 替换成站标favicon路径或者任意存在的较小的图片即可
    iframe.setAttribute("src", "https://m.eyenurse.net/mall/favicon.ico");
    var iframeCallback = function iframeCallback() {
      setTimeout(function () {
        iframe.removeEventListener("load", iframeCallback);
        document.body.removeChild(iframe);
      }, 0);
    };
    iframe.addEventListener("load", iframeCallback);
    document.body.appendChild(iframe);
  }
}

// 为数字加上单位：万或亿
function addWan(integer, number, mutiple, decimalDigit) {
  var digit = getDigit(integer);
  if (digit > 3) {
    var remainder = digit % 8;
    if (remainder >= 5) {
      // ‘十万’、‘百万’、‘千万’显示为‘万’
      remainder = 4;
    }
    return Math.round(number / Math.pow(10, remainder + mutiple - decimalDigit)) / Math.pow(10, decimalDigit) + "万";
  } else {
    return Math.round(number / Math.pow(10, mutiple - decimalDigit)) / Math.pow(10, decimalDigit);
  }
}
function getDigit(integer) {
  var digit = -1;
  while (integer >= 1) {
    digit++;
    integer = integer / 10;
  }
  return digit;
}

//添加中文单位
export function addChineseUnit(number, decimalDigit) {
  decimalDigit = decimalDigit == null ? 2 : decimalDigit;
  var integer = Math.floor(number);
  var digit = getDigit(integer);
  // ['个', '十', '百', '千', '万', '十万', '百万', '千万'];
  var unit = [];
  if (digit > 3) {
    var multiple = Math.floor(digit / 8);
    if (multiple >= 1) {
      var tmp = Math.round(integer / Math.pow(10, 8 * multiple));
      unit.push(addWan(tmp, number, 8 * multiple, decimalDigit));
      for (var i = 0; i < multiple; i++) {
        unit.push("亿");
      }
      return unit.join("");
    } else {
      return addWan(integer, number, 0, decimalDigit);
    }
  } else {
    return number;
  }
}

// 限制输入框输入的字符数
export function widthCheck(str, len) {
  var temp = 0;
  for (var i = 0; i < str.length; i++) {
    if (/[\u4e00-\u9fa5]/.test(str[i])) {
      temp += 2;
    } else {
      temp++;
    }
    if (temp > len) {
      str = str.substr(0, i);
    }
  }
  return str;
}
// 
/**
 * 获取 blob
 * @param  {String} url 目标文件地址
 * @return {Promise}
 */
export function getBlob(url) {
  return new Promise(function (resolve) {
    var xhr = new XMLHttpRequest();
    xhr.open("GET", url, true);
    xhr.responseType = "blob";
    xhr.onload = function () {
      if (xhr.status === 200) {
        resolve(xhr.response);
      }
    };
    xhr.send();
  });
}

/**
 * 保存
 * @param  {Blob} blob
 * @param  {String} filename 想要保存的文件名称
 */
export function saveAs(blob, filename) {
  if (window.navigator.msSaveOrOpenBlob) {
    navigator.msSaveBlob(blob, filename);
  } else {
    var link = document.createElement("a");
    var body = document.querySelector("body");
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;

    // fix Firefox
    link.style.display = "none";
    body.appendChild(link);
    link.click();
    body.removeChild(link);
    window.URL.revokeObjectURL(link.href);
  }
}

/**
 * 下载
 * @param  {String} url 目标文件地址
 * @param  {String} filename 想要保存的文件名称
 */
export function download(url, filename) {
  getBlob(url).then(function (blob) {
    saveAs(blob, filename);
  });
}

// 监听键盘滚动(解决键盘挡住输入框)
export function scrollIntoViewCenter() {
  var u = navigator.userAgent;
  if (u.indexOf("Android") > -1 || u.indexOf("Adr") > -1) {
    window.addEventListener("resize", function () {
      if (document.activeElement.tagName == "INPUT" || document.activeElement.tagName == "TEXTAREA") {
        window.setTimeout(function () {
          document.activeElement.scrollIntoView({
            block: 'center'
          });
        }, 0);
      }
    });
  }
}

/**
 * 字符串加密
 * @param {String} originStr 要加密的字符串
 * @returns 加密后的字符串
 */
import CryptoJS from "crypto-js";
export function encryptionStr(originStr) {
  // utf8处理
  var tempStr = CryptoJS.enc.Utf8.parse(originStr);
  var key = CryptoJS.enc.Utf8.parse('y2W89L6BkRAFljhN');
  var iv = CryptoJS.enc.Utf8.parse('dMitHORyqbeYVE0o');

  // CryptoJS.pad.Pkcs7
  var encrypted = CryptoJS.AES.encrypt(tempStr, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.toString();
}

// 初始化图片预览
export function initImagePreview() {
  var fartherDom = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "#app";
  setTimeout(function () {
    var _fartherDom = document.querySelector(fartherDom);
    console.log(_fartherDom);
    var clickImgs = [];
    clickImgs = _fartherDom.getElementsByTagName("img");
    var imgSrcList = [];
    var _loop = function _loop(i) {
      imgSrcList.push(clickImgs[i].src);
      clickImgs[i].onclick = function () {
        _ImagePreview({
          images: imgSrcList,
          startPosition: i
        });
      };
    };
    for (var i = 0; i < clickImgs.length; i++) {
      _loop(i);
    }
  }, 50);
}

//异步 获取服务器时间
// export function asyncNewServerDate(timeout = 3000) {
//   return new Promise((resolve) => {
//     const request = new XMLHttpRequest()
//     request.timeout = timeout
//     request.open("GET", process.env.VUE_APP_BASE_IMGURI + '/serverdate/', true)
//     request.send()
//     request.onreadystatechange = function () {
//       if (request.responseText) {
//         resolve(new Date(request.responseText))
//       } else {
//         resolve(new Date())  //没网情况获取本地时间
//       }
//     }
//   })
// }

export function asyncNewServerDate() {
  var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 3000;
  return new Promise(function (resolve, reject) {
    var request = new XMLHttpRequest();
    request.timeout = timeout;
    request.open("GET", process.env.VUE_APP_BASE_IMGURI + '/serverdate/', true);
    request.onload = function () {
      if (request.status === 200) {
        console.log('来自服务器');
        resolve(new Date(request.responseText));
      } else {
        console.log('来自本地');
        resolve(new Date()); // 没网情况获取本地时间
      }
    };
    request.ontimeout = function () {
      console.log('请求超时，来自本地');
      resolve(new Date()); // 超时情况获取本地时间
    };
    request.onerror = function () {
      console.log('请求错误，来自本地');
      resolve(new Date()); // 请求错误情况获取本地时间
    };
    request.send();
  });
}

//同步 获取服务器时间代替 new Date() (需要在服务器配置nginx)
export function newServerDate() {
  var request = new XMLHttpRequest();
  request.open("GET", process.env.VUE_APP_BASE_IMGURI + '/serverdate/', false); //同步
  request.send();
  if (request.responseText) {
    return new Date(request.responseText);
  } else {
    return new Date(); //没网情况获取本地时间
  }
}

//数字格式化
export function formatNumber(num) {
  if (typeof num !== 'number') {
    return num;
  }
  // 将数字转换为字符串
  var str = num.toString();

  // 如果数字小于1000，则直接返回原始字符串
  if (str.length < 4) {
    return str;
  }

  // 计算需要插入几个逗号
  var commaCount = Math.floor((str.length - 1) / 3);

  // 在正确的位置插入逗号
  var result = '';
  var index = 0;
  for (var i = str.length - 1; i >= 0; i--) {
    result = str.charAt(i) + result;
    index++;
    if (index % 3 === 0 && commaCount > 0) {
      result = ',' + result;
      commaCount--;
    }
  }
  return result;
}

// 获取指定时间段提示字
export function getTimeState() {
  // 获取当前时间
  var timeNow = new Date();
  // 获取当前小时
  var hours = timeNow.getHours();
  // 设置默认文字
  var state = "";
  // 判断当前时间段
  if (hours >= 0 && hours <= 10) {
    state = "\u65E9\u4E0A\u597D\uFF01";
  } else if (hours > 10 && hours <= 11) {
    state = "\u4E0A\u5348\u597D\uFF01";
  } else if (hours > 11 && hours <= 13) {
    state = "\u4E2D\u5348\u597D\uFF01";
  } else if (hours > 13 && hours <= 18) {
    state = "\u4E0B\u5348\u597D\uFF01";
  } else if (hours > 18 && hours <= 24) {
    state = "\u665A\u4E0A\u597D\uFF01";
  }
  return state;
}

// 判断答题条件等式是否成立
export function equalValidate(answerArr) {
  var sum = 0;
  for (var i = 1; i < answerArr.length; i++) {
    var num = parseInt(answerArr[i]);
    if (!isNaN(num)) {
      sum += num;
    }
  }
  var firstItem = parseInt(answerArr[0]);
  if (!isNaN(firstItem) && firstItem === sum) {
    return true;
  } else {
    return false;
  }
}

//根据身份证号获取出生日期
export function extractBirthdate(sno) {
  var birthdate = '';
  if (sno.length === 18) {
    birthdate = sno.slice(6, 14); // 提取出生日期部分
  } else if (sno.length === 15) {
    birthdate = '19' + sno.slice(6, 12); // 提取出生日期部分
  }
  var year = birthdate.slice(0, 4);
  var month = birthdate.slice(4, 6);
  var day = birthdate.slice(6, 8);
  return "".concat(year, "-").concat(month, "-").concat(day);
}

//封装节流函数
import _ from 'lodash';
export function throttle(func, time) {
  return _.throttle(func, time || 2500, {
    trailing: false
  });
}

//根据出生日期计算年龄
export function calculateAge(birthDate) {
  var today = new Date();
  var birth = new Date(birthDate);
  var age = today.getFullYear() - birth.getFullYear();
  var monthDiff = today.getMonth() - birth.getMonth();
  if (monthDiff < 0 || monthDiff === 0 && today.getDate() < birth.getDate()) {
    age--;
  }
  return age;
}

//根据出生日期计算年龄，精确到小数点后一位
export function calculateAgeWithHalf(birthDate) {
  var current = new Date();
  var birth = new Date(birthDate);
  var ageDiff = current - birth;
  var ageInYears = ageDiff / (1000 * 60 * 60 * 24 * 365.25);
  var roundedAge = (Math.floor(ageInYears * 100) / 100).toFixed(2);
  return roundedAge;
}

//根据身份证号获取性别
export function getSexBySno(sno) {
  if (sno) {
    var sex;
    if (sno.length == 18) {
      // 二代身份证号码长度为18位（第17位为性别代码）
      sex = sno.charAt(16);
    } else if (sno.length == 15) {
      // 一代身份证号码长度为15位（第15位为性别代码）
      sex = sno.charAt(14);
    }
    if (sex && !isNaN(sex)) {
      // 两代身份证号码的性别代码都为男奇女偶
      if (parseInt(sex) % 2 == 0) {
        return 2;
      }
      return 1;
    }
  }
}

//判断结核分支杆菌感染检测症状
export function checkPPD(ppd_hj2, ppd_zj2, ppd_lczz2) {
  switch (ppd_lczz2) {
    case 1:
      if (ppd_hj2 && ppd_zj2) {
        var averageVal = (Number(ppd_hj2) + Number(ppd_zj2)) / 2;
        if (averageVal < 5) {
          return '阴性';
        } else if (averageVal >= 5 && averageVal < 10) {
          return '一般阴性';
        } else if (averageVal >= 10 && averageVal < 15) {
          return '中度阴性';
        } else if (averageVal >= 15) {
          return '强阳性';
        }
      } else {
        return '';
      }
    case 2:
    case 3:
    case 4:
    case 5:
      return '强阳性';
    default:
      return '';
  }
}